import { call, put } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as StoreCreators } from "../ducks/store";
import { Creators as DomainCreators } from "../ducks/domain";
import { Creators as UserCreators } from "../ducks/user";
import { Creators as MenuCreators } from "../ducks/menu";
import { Creators as IdentidadeVisualCreators } from "../ducks/identidadeVisual";

export function* getStoreByDomain() {
  try {
    const response = yield call(api.get, `/stores/domain`);

    if (!response.data.store.empresa.politica_privacidade && !response.data.store.empresa.politica_privacidade_html)
      response.data.store.empresa.politica_privacidade = `/companies/${response.data.store.empresa.url}/politica_privacidade.html`

    if (response.data.store.empresa.url === 'farmasul') {
      if (!response.data.store.empresa.politica_troca_devolucao)
        response.data.store.empresa.politica_troca_devolucao = `/companies/${response.data.store.empresa.url}/politica_troca_devolucao.html`

      response.data.store.empresa.politica_pagamento = `/companies/${response.data.store.empresa.url}/politica_pagamento.html`

      response.data.store.empresa.politica_entrega = `/companies/${response.data.store.empresa.url}/politica_entrega.html`
    }

    let identidadeData = null;
    try {
      const identidadeResponse = yield call(api.get, "/identidade-visual");
      identidadeData = identidadeResponse.data;
    } catch (identidadeErr) {
      yield put(IdentidadeVisualCreators.fetchIdentidadeVisualFailure(identidadeErr?.message));
    }

    yield put(UserCreators.removeLoading());
    yield put(MenuCreators.getSuccess(response.data.menu));
    yield put(StoreCreators.getSuccess(response.data.store));

    if (identidadeData) {
      yield put(IdentidadeVisualCreators.fetchIdentidadeVisualSuccess(identidadeData));
    }

    // Despachado por ultimo: quando allowedDomain vira true, store e
    // identidade visual (cor_primaria) ja estao no estado, evitando flash de tema.
    yield put(DomainCreators.getDomainSuccess());
  } catch (err) {
    yield put(DomainCreators.getDomainFailure(err?.response?.data?.message ?? err.message));
  }
}
